// src/components/Footer.js
import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer id="footer" className="footer dark-background">
      <div className="container">
        <div className="row gy-3 rere">
          {/* Address */}
          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-geo-alt icon"></i>
            <div className="address">
              <h4>Address</h4>
              <p>
                Jl. Raya Pati - Kudus Km.4 Gg. Desa Badegan, Kecamatan Margorejo
              </p>
              <p>Jawa Tengah 59163</p>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-telephone icon"></i>
            <div>
              <h4>Contact</h4>
              <p>
                <strong>Phone:</strong> <span>081 272 800 800</span>
                <br />
                <strong>Email:</strong>{" "}
                <span>originalitycloth2016@gmail.com</span>
                <br />
              </p>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="col-lg-3 col-md-6 d-flex">
            <i className="bi bi-clock icon"></i>
            <div>
              <h4>Opening Hours</h4>
              <p>
                <strong>Mon-Sat:</strong> <span>8:00 AM - 5:00 PM</span>
                <br />
                <strong>Sunday:</strong> <span>Closed</span>
              </p>
            </div>
          </div>

          {/* Follow Us */}
          <div className="col-lg-3 col-md-6">
            <h4>Follow Us</h4>
            <div className="social-links d-flex flex-wrap">
              <a
                href="https://wa.me/6281272800800"
                className="twitter"
                target="_blank"
              >
                <i className="bi bi-whatsapp"></i>
              </a>
              <a
                href="https://www.instagram.com/originality2016/"
                className="instagram"
                target="_blank"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.tiktok.com/@originality2016"
                className="linkedin"
                target="_blank"
              >
                <i className="bi bi-tiktok"></i>
              </a>
              <a href="#" className="facebook">
                <i className="bi bi-facebook"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="container copyright text-center mt-4">
        <p>
          © <span>Copyright</span>{" "}
          <strong className="px-1 sitename">Originality</strong>
          <span>All Rights Reserved</span>
        </p>
        {/* <div className="credits">
          Designed by
          <a href="https://github.com/AgungDev">Ganz</a> Distributed by
          <a href="https://originality.com">Originality</a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
